import {
    IAdvancedContest,
    IContest,
    IContestAward,
    IContestPrize,
    IContestSubmissionsWithVotes,
    ILocation,
    IProject,
    IReedemableCode,
    ISale,
    ISaleObject,
    ISubmission,
    IUserSummary,
    SubmissionCategory,
    TContestGenre,
    UserSummary,
} from '../../types/global/helper';
import { IProjectSummary } from '../../types/global/media.types';
import { ICurrencyInfo, IDiscount } from '../checkout/types';
import { IHost, IPartner } from '../discovery/types';
import { AwardStatus } from '../festival/types';
import { IJurySetings } from '../jury/types';

export const types = {
    GET_BOOKMARK: 'GET_BOOKMARK',
    GET_BOOKMARK_SUCCESS: 'GET_BOOKMARK_SUCCESS',
    GET_BOOKMARK_FAIL: 'GET_BOOKMARK_FAIL',

    DELETE_BOOKMARK: 'DELETE_BOOKMARK',
    DELETE_BOOKMARK_SUCCESS: 'DELETE_BOOKMARK_SUCCESS',
    DELETE_BOOKMARK_FAIL: 'DELETE_BOOKMARK_FAIL',

    CREATE_CONTEST: 'CREATE_CONTEST',
    CREATE_CONTEST_SUCCESS: 'CREATE_CONTEST_SUCCESS',
    CREATE_CONTEST_FAIL: 'CREATE_CONTEST_FAIL',

    UPDATE_CONTEST: 'UPDATE_CONTEST',
    UPDATE_CONTEST_SUCCESS: 'UPDATE_CONTEST_SUCCESS',
    UPDATE_CONTEST_FAIL: 'UPDATE_CONTEST_FAIL',

    PROVISION_CONTEST_CATEGORIES: 'PROVISION_CONTEST_CATEGORIES',
    PROVISION_CONTEST_CATEGORIES_SUCCESS: 'PROVISION_CONTEST_CATEGORIES_SUCCESS',
    PROVISION_CONTEST_CATEGORIES_FAIL: 'PROVISION_CONTEST_CATEGORIES_FAIL',

    CONVERT_CONTEST_SUBMISSION_MODE: 'CONVERT_CONTEST_SUBMISSION_MODE',
    CONVERT_CONTEST_SUBMISSION_MODE_SUCCESS: 'CONVERT_CONTEST_SUBMISSION_MODE_SUCCESS',
    CONVERT_CONTEST_SUBMISSION_MODE_FAIL: 'CONVERT_CONTEST_SUBMISSION_MODE_FAIL',

    GET_USER_CONTESTS: 'GET_USER_CONTESTS',
    GET_USER_CONTESTS_SUCCESS: 'GET_USER_CONTESTS_SUCCESS',
    GET_USER_CONTESTS_FAIL: 'GET_USER_CONTESTS_FAIL',

    GET_USER_CONTEST: 'GET_USER_CONTEST',
    GET_USER_CONTEST_SUCCESS: 'GET_USER_CONTEST_SUCCESS',
    GET_USER_CONTEST_FAIL: 'GET_USER_CONTEST_FAIL',

    GET_CONTESTS: 'GET_CONTESTS',
    GET_CONTESTS_SUCCESS: 'GET_CONTESTS_SUCCESS',
    GET_CONTESTS_FAIL: 'GET_CONTESTS_FAIL',

    GET_CONTEST: 'GET_CONTEST',
    GET_CONTEST_SUCCESS: 'GET_CONTEST_SUCCESS',
    GET_CONTEST_FAIL: 'GET_CONTEST_FAIL',

    GET_RECOMMENDATION: 'GET_RECOMMENDATION',
    GET_RECOMMENDATION_SUCCESS: 'GET_RECOMMENDATION_SUCCESS',
    GET_RECOMMENDATION_FAIL: 'GET_RECOMMENDATION_FAIL',

    DELETE_CONTEST: 'DELETE_CONTEST',
    DELETE_CONTEST_SUCCESS: 'DELETE_CONTEST_SUCCESS',
    DELETE_CONTEST_FAIL: 'DELETE_CONTEST_FAIL',

    PUBLISH_CONTEST: 'PUBLISH_CONTEST',
    PUBLISH_CONTEST_SUCCESS: 'PUBLISH_CONTEST_SUCCESS',
    PUBLISH_CONTEST_FAIL: 'PUBLISH_CONTEST_FAIL',

    GET_CONTEST_FUNDING_REQUIREMENTS: 'GET_CONTEST_FUNDING_REQUIREMENTS',
    FUND_CONTEST_FROM_WALLET: 'FUND_CONTEST_FROM_WALLET',

    UNPUBLISH_CONTEST: 'UNPUBLISH_CONTEST',
    UNPUBLISH_CONTEST_SUCCESS: 'UNPUBLISH_CONTEST_SUCCESS',
    UNPUBLISH_CONTEST_FAIL: 'UNPUBLISH_CONTEST_FAIL',

    SUBMIT_PROJECT: 'SUBMIT_PROJECT',
    SUBMIT_PROJECT_SUCCESS: 'SUBMIT_PROJECT_SUCCESS',
    SUBMIT_PROJECT_FAIL: 'SUBMIT_PROJECT_FAIL',

    COMPLETE_SUBMISSION_PAYMENT: 'COMPLETE_SUBMISSION_PAYMENT',
    COMPLETE_SUBMISSION_PAYMENT_SUCCESS: 'COMPLETE_SUBMISSION_PAYMENT_SUCCESS',
    COMPLETE_SUBMISSION_PAYMENT_FAIL: 'COMPLETE_SUBMISSION_PAYMENT_FAIL',

    REQUEST_SUBMISSION_PAYMENT: 'REQUEST_SUBMISSION_PAYMENT',
    REQUEST_SUBMISSION_PAYMENT_SUCCESS: 'REQUEST_SUBMISSION_PAYMENT_SUCCESS',
    REQUEST_SUBMISSION_PAYMENT_FAIL: 'REQUEST_SUBMISSION_PAYMENT_FAIL',

    GET_MY_SUBMISSIONS: 'GET_MY_SUBMISSIONS',
    GET_MY_SUBMISSIONS_SUCCESS: 'GET_MY_SUBMISSIONS_SUCCESS',
    GET_MY_SUBMISSIONS_FAIL: 'GET_MY_SUBMISSIONS_FAIL',

    RESCIND_SUBMISSION: 'RESCIND_SUBMISSION',
    RESCIND_SUBMISSION_SUCCESS: 'RESCIND_SUBMISSION_SUCCESS',
    RESCIND_SUBMISSION_FAIL: 'RESCIND_SUBMISSION_FAIL',

    UPDATE_SUBMISSION: 'UPDATE_SUBMISSION',
    UPDATE_SUBMISSION_SUCCESS: 'UPDATE_SUBMISSION_SUCCESS',
    UPDATE_SUBMISSION_FAIL: 'UPDATE_SUBMISSION_FAIL',

    SET_SUBMISSION_MODAL_STATE: 'SET_SUBMISSION_MODAL_STATE',
    SET_CONTEST_FOR_SUBMISSION: 'SET_CONTEST_FOR_SUBMISSION',
    RESET_CONTEST_DATA: 'RESET_CONTEST_DATA',

    VOTE_FOR_SUBMISSION: 'VOTE_FOR_SUBMISSION',
    VOTE_FOR_SUBMISSION_SUCCESS: 'VOTE_FOR_SUBMISSION_SUCCESS',
    VOTE_FOR_SUBMISSION_FAIL: 'VOTE_FOR_SUBMISSION_FAIL',

    INITIATE_2FA_FOR_VOTE: 'INITIATE_2FA_FOR_VOTE',
    INITIATE_2FA_FOR_VOTE_SUCCESS: 'INITIATE_2FA_FOR_VOTE_SUCCESS',
    INITIATE_2FA_FOR_VOTE_FAIL: 'INITIATE_2FA_FOR_VOTE_FAIL',

    GET_USER_VOTER_ID: 'GET_USER_VOTER_ID',
    GET_USER_VOTER_ID_SUCCESS: 'GET_USER_VOTER_ID_SUCCESS',
    GET_USER_VOTER_ID_FAIL: 'GET_USER_VOTER_ID_FAIL',

    CREATE_BOOKMARK: 'CREATE_BOOKMARK',
    CREATE_BOOKMARK_SUCCESS: 'CREATE_BOOKMARK_SUCCESS',
    CREATE_BOOKMARK_FAIL: 'CREATE_BOOKMARK_FAIL',

    CREATE_HOST: 'CREATE_HOST',
    CREATE_HOST_SUCCESS: 'CREATE_HOST_SUCCESS',
    CREATE_HOST_FAIL: 'CREATE_HOST_FAIL',

    GET_HOST: 'GET_HOST',
    GET_HOST_SUCCESS: 'GET_HOST_SUCCESS',
    GET_HOST_FAIL: 'GET_HOST_FAIL',

    GET_ALL_HOSTS: 'GET_ALL_HOSTS',
    GET_ALL_HOSTS_SUCCESS: 'GET_ALL_HOSTS_SUCCESS',
    GET_ALL_HOSTS_FAIL: 'GET_ALL_HOSTS_FAIL',

    UPDATE_HOST: 'UPDATE_HOST',
    UPDATE_HOST_SUCCESS: 'UPDATE_HOST_SUCCESS',
    UPDATE_HOST_FAIL: 'UPDATE_HOST_FAIL',

    DELETE_HOST: 'DELETE_HOST',
    DELETE_HOST_SUCCESS: 'DELETE_HOST_SUCCESS',
    DELETE_HOST_FAIL: 'DELETE_HOST_FAIL',

    CREATE_PARTNER: 'CREATE_PARTNER',
    CREATE_PARTNER_SUCCESS: 'CREATE_PARTNER_SUCCESS',
    CREATE_PARTNER_FAIL: 'CREATE_PARTNER_FAIL',

    GET_PARTNER: 'GET_PARTNER',
    GET_PARTNER_SUCCESS: 'GET_PARTNER_SUCCESS',
    GET_PARTNER_FAIL: 'GET_PARTNER_FAIL',

    GET_ALL_PARTNERS: 'GET_ALL_PARTNERS',
    GET_ALL_PARTNERS_SUCCESS: 'GET_ALL_PARTNERS_SUCCESS',
    GET_ALL_PARTNERS_FAIL: 'GET_ALL_PARTNERS_FAIL',

    UPDATE_PARTNER: 'UPDATE_PARTNER',
    UPDATE_PARTNER_SUCCESS: 'UPDATE_PARTNER_SUCCESS',
    UPDATE_PARTNER_FAIL: 'UPDATE_PARTNER_FAIL',

    DELETE_PARTNER: 'DELETE_PARTNER',
    DELETE_PARTNER_SUCCESS: 'DELETE_PARTNER_SUCCESS',
    DELETE_PARTNER_FAIL: 'DELETE_PARTNER_FAIL',

    SEARCH_HOST: 'SEARCH_HOST',
    SEARCH_HOST_SUCCESS: 'SEARCH_HOST_SUCCESS',
    SEARCH_HOST_FAIL: 'SEARCH_HOST_FAIL',

    SEARCH_PARTNER: 'SEARCH_PARTNER',
    SEARCH_PARTNER_SUCCESS: 'SEARCH_PARTNER_SUCCESS',
    SEARCH_PARTNER_FAIL: 'SEARCH_PARTNER_FAIL',

    CREATE_AWARD_CATEGORY: 'CREATE_AWARD_CATEGORY',
    CREATE_AWARD_CATEGORY_SUCCESS: 'CREATE_AWARD_CATEGORY_SUCCESS',
    CREATE_AWARD_CATEGORY_FAIL: 'CREATE_AWARD_CATEGORY_FAIL',

    DELETE_AWARD_CATEGORY: 'DELETE_AWARD_CATEGORY',
    DELETE_AWARD_CATEGORY_SUCCESS: 'DELETE_AWARD_CATEGORY_SUCCESS',
    DELETE_AWARD_CATEGORY_FAIL: 'DELETE_AWARD_CATEGORY_FAIL',

    UPDATE_AWARD_CATEGORY: 'UPDATE_AWARD_CATEGORY',
    UPDATE_AWARD_CATEGORY_SUCCESS: 'UPDATE_AWARD_CATEGORY_SUCCESS',
    UPDATE_AWARD_CATEGORY_FAIL: 'UPDATE_AWARD_CATEGORY_FAIL',

    SET_CONTEST_FOR_EDIT: 'SET_CONTEST_FOR_EDIT',

    GET_REDEEMABLE_CODE: 'GET_REDEEMABLE_CODE',
    GET_REDEEMABLE_CODE_SUCCESS: 'GET_REDEEMABLE_CODE_SUCCESS',
    GET_REDEEMABLE_CODE_FAIL: 'GET_REDEEMABLE_CODE_FAIL',

    ASSIGN_REDEEMABLE_CODE: 'ASSIGN_REDEEMABLE_CODE',
    ASSIGN_REDEEMABLE_CODE_SUCCESS: 'ASSIGN_REDEEMABLE_CODE_SUCCESS',
    ASSIGN_REDEEMABLE_CODE_FAIL: 'ASSIGN_REDEEMABLE_CODE_FAIL',

    DOWNLOAD_ASSET: 'DOWNLOAD_ASSET',
    DOWNLOAD_ASSET_SUCCESS: 'DOWNLOAD_ASSET_SUCCESS',
    DOWNLOAD_ASSET_FAIL: 'DOWNLOAD_ASSET_FAIL',

    SET_VOTING_FLOW: 'SET_VOTING_FLOW',
    SET_VOTING_2FA: 'SET_VOTING_2FA',
    SET_VOTING_2FA_STARTING_INDEX: 'SET_VOTING_2FA_STARTING_INDEX',

    GET_AWARD_CATEGORIES_FOR_CONTEST: 'GET_AWARD_CATEGORIES_FOR_CONTEST',
    GET_AWARD_CATEGORIES_FOR_CONTEST_SUCCESS: 'GET_AWARD_CATEGORIES_FOR_CONTEST_SUCCESS',
    GET_AWARD_CATEGORIES_FOR_CONTEST_FAIL: 'GET_AWARD_CATEGORIES_FOR_CONTEST_FAIL',

    GET_AWARDED_PRIZES_FOR_CONTEST: 'GET_AWARDED_PRIZES_FOR_CONTEST',
    GET_AWARDED_PRIZES_FOR_CONTEST_SUCCESS: 'GET_AWARDED_PRIZES_FOR_CONTEST_SUCCESS',
    GET_AWARDED_PRIZES_FOR_CONTEST_FAIL: 'GET_AWARDED_PRIZES_FOR_CONTEST_FAIL',

    AWARD_PRIZE: 'AWARD_PRIZE',
    AWARD_PRIZE_SUCCESS: 'AWARD_PRIZE_SUCCESS',
    AWARD_PRIZE_FAIL: 'AWARD_PRIZE_FAIL',

    SEND_WINNERS_EMAIL: 'SEND_WINNERS_EMAIL',
    SEND_WINNERS_EMAIL_SUCCESS: 'SEND_WINNERS_EMAIL_SUCCESS',
    SEND_WINNERS_EMAIL_FAIL: 'SEND_WINNERS_EMAIL_FAIL',

    SEND_CONTEST_EMAIL: 'SEND_CONTEST_EMAIL',
    SEND_CONTEST_EMAIL_SUCCESS: 'SEND_CONTEST_EMAIL_SUCCESS',
    SEND_CONTEST_EMAIL_FAIL: 'SEND_CONTEST_EMAIL_FAIL',

    SET_SUBMISSION_PROMPT: 'SET_SUBMISSION_PROMPT',

    SET_AUTO_PUBLISH_AND_SUBMIT: 'SET_AUTO_PUBLISH_AND_SUBMIT',

    GET_ALL_SUBMISSIONS: 'GET_ALL_SUBMISSIONS',
    GET_ALL_SUBMISSIONS_SUCCESS: 'GET_ALL_SUBMISSIONS_SUCCESS',
    GET_ALL_SUBMISSIONS_FAIL: 'GET_ALL_SUBMISSIONS_FAIL',

    CREATE_SCORE_CATEGORY: 'CREATE_SCORE_CATEGORY',
    CREATE_SCORE_CATEGORY_SUCCESS: 'CREATE_SCORE_CATEGORY_SUCCESS',
    CREATE_SCORE_CATEGORY_FAIL: 'CREATE_SCORE_CATEGORY_FAIL',

    DELETE_SCORE_CATEGORY: 'DELETE_SCORE_CATEGORY',
    DELETE_SCORE_CATEGORY_SUCCESS: 'DELETE_SCORE_CATEGORY_SUCCESS',
    DELETE_SCORE_CATEGORY_FAIL: 'DELETE_SCORE_CATEGORY_FAIL',

    UPDATE_SCORE_CATEGORY: 'UPDATE_SCORE_CATEGORY',
    UPDATE_SCORE_CATEGORY_SUCCESS: 'UPDATE_SCORE_CATEGORY_SUCCESS',
    UPDATE_SCORE_CATEGORY_FAIL: 'UPDATE_SCORE_CATEGORY_FAIL',

    SET_FOCUS_CAMPAIGN: 'SET_FOCUS_CAMPAIGN',

    SET_EMAIL_IMAGE: 'SET_EMAIL_IMAGE',

    RESET_VOTE: 'RESET_VOTE',

    GET_CONTEST_REFERENCES: 'GET_CONTEST_REFERNCES',
    GET_CONTEST_REFERENCES_SUCCESS: 'GET_CONTEST_REFERNCES_SUCCESS',
    GET_CONTEST_REFERENCES_FAIL: 'GET_CONTEST_REFERNCES_FAIL',

    GET_USERS_UNSUBMITTED_PROJECTS: 'GET_USERS_UNSUBMITTED_PROJECTS',
    GET_USERS_UNSUBMITTED_PROJECTS_SUCCESSS: 'GET_USERS_UNSUBMITTED_PROJECTS_SUCCESS',
    GET_USERS_UNSUBMITTED_PROJECTS_FAIL: 'GET_USERS_UNSUBMITTED_PROJECTS_FAIL',

    SET_CATEGORY_FOR_SUBMISSION: 'SET_CATEGORY_FOR_SUBMISSION',

    GET_S3_IMAGES: 'GET_S3_IMAGES',
    GET_S3_IMAGES_SUCCESS: 'GET_S3_IMAGES_SUCCESS',
    GET_S3_IMAGES_FAIL: 'GET_S3_IMAGES_FAIL',

    GET_CONTEST_SUBMISSIONS: 'GET_CONTEST_SUBMISSIONS',
    GET_CONTEST_SUBMISSIONS_SUCCESS: 'GET_CONTEST_SUBMISSIONS_SUCCESS',
    GET_CONTEST_SUBMISSIONS_FAIL: 'GET_CONTEST_SUBMISSIONS_FAIL',
    SET_SEARCHING_CONTEST_SUBMISSIONS: 'SET_SEARCHING_CONTEST_SUBMISSIONS',

    GET_MANAGE_CAMPAIGN: 'GET_MANAGE_CAMPAIGN',
    GET_MANAGE_CAMPAIGN_SUCCESS: 'GET_MANAGE_CAMPAIGN_SUCCESS',
    GET_MANAGE_CAMPAIGN_FAIL: 'GET_MANAGE_CAMPAIGN_FAIL',

    UPDATE_CAMPAIGN_AWARDS: 'UPDATE_CAMPAIGN_AWARDS',
    UPDATE_CAMPAIGN_AWARDS_SUCCESS: 'UPDATE_CAMPAIGN_AWARDS_SUCCESS',
    UPDATE_CAMPAIGN_AWARDS_FAIL: 'UPDATE_CAMPAIGN_AWARDS_FAIL',

    SET_DISCOUNT_CODE: 'SET_DISCOUNT_CODE',
    CLEAR_DISCOUNT_CODE: 'CLEAR_DISCOUNT_CODE',

    FUNDING_COMPLETE: 'FUNDING_COMPLETE',

    VERIFY_PROJECT_SUBMISSION: 'VERIFY_PROJECT_SUBMISSION',
    VERIFY_PROJECT_SUBMISSION_SUCCESS: 'VERIFY_PROJECT_SUBMISSION_SUCCESS',
    VERIFY_PROJECT_SUBMISSION_FAIL: 'VERIFY_PROJECT_SUBMISSION_FAIL',

    SET_SELECTED_PROJECT: 'SET_SELECTED_PROJECT',
    GET_PRESELECTION_SUBMISSIONS: 'GET_PRESELECTION_SUBMISSIONS',
    GET_PRESELECTION_SUBMISSIONS_SUCCESS: 'GET_PRESELECTION_SUBMISSIONS_SUCCESS',
    GET_PRESELECTION_SUBMISSIONS_FAIL: 'GET_PRESELECTION_SUBMISSIONS_FAIL',
    PRESELECT_SUBMISSIONS: 'PRESELECT_SUBMISSIONS',
    PRESELECT_SUBMISSIONS_SUCCESS: 'PRESELECT_SUBMISSIONS_SUCCESS',
    PRESELECT_SUBMISSIONS_FAIL: 'PRESELECT_SUBMISSIONS_FAIL',
    SEND_SELECTION_EMAIL: 'SEND_SELECTION_EMAIL',
    SEND_SELECTION_EMAIL_SUCCESS: 'SEND_SELECTION_EMAIL_SUCCESS',
    SEND_SELECTION_EMAIL_FAIL: 'SEND_SELECTION_EMAIL_FAIL',

    UPDATE_VIDEO_MANAGEMENT_FILTERS: 'UPDATE_VIDEO_MANAGEMENT_FILTERS',
    SET_SELECTED_VIDEOS: 'SET_SELECTED_VIDEOS',
    CLEAR_SELECTED_VIDEOS: 'CLEAR_SELECTED_VIDEOS',

    SET_CONTEST_FOR_TOKENS: 'SET_CONTEST_FOR_TOKENS',

    LOAD_SUBMISSION_PAYMENT_CHECKOUT: 'LOAD_SUBMISSION_PAYMENT_CHECKOUT',
    LOAD_SUBMISSION_PAYMENT_CHECKOUT_SUCCESS: 'LOAD_SUBMISSION_PAYMENT_CHECKOUT_SUCCESS',
    LOAD_SUBMISSION_PAYMENT_CHECKOUT_FAIL: 'LOAD_SUBMISSION_PAYMENT_CHECKOUT_FAIL',
};

export interface IVerifyProject {
    message: 'eligible' | 'ineligible';
    reason: string;
}

export interface IUpdateCampaignAwards {
    awardCategoryId: string;
    contestId: string;
    categoryId: string;
    action: 'add' | 'remove';
}

export interface IUpdateAwardCategorySuccess {
    body: IAwardCategory;
    payload: any;
}

export interface IGetContestPayload {
    contestId: string;
    withNavigate?: boolean;
    /** Allows us to add search=true to teh query to create activity for the search document */
    params?: string;
    /** Sets whether this will use the contest_id instead */
    isEvent?: boolean;
}

export interface IGetContestResponse {
    data: IContest;
}
export interface IGetS3ImagesPayload {
    page?: number;
    limit?: number;
    /** When true, append to `s3Images` instead of replacing */
    append?: boolean;
}

export interface IS3ImagesPagination {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
}

export interface IGetS3ImagesSuccessPayload {
    images: string[];
    pagination: IS3ImagesPagination;
    append: boolean;
}

/** @deprecated legacy shape — use IGetS3ImagesSuccessPayload */
export interface IGetS3ImagesResponse {
    status: string;
    data: {
        s3Images: string[];
    };
}

type TRating = 'G' | 'PG' | 'PG-13' | 'R' | 'NC-17' | 'NR' | 'NR-17';
type TVoting = 'daily' | 'weekly' | 'one-off' | 'hourly' | 'voting';
type TMedia = 'video' | 'audio' | 'picture' | 'document';
type TKind = 'physical' | 'online';
export type TProjectFormat = 'act' | 'video';

type TTechnicalSpec = {
    min_duration: number;
    max_duration: number;
    media_type: TMedia;
    /** Submit vertical or horixontal videos */
    project_format: TProjectFormat;
};

export interface ICreateContestPayload {
    title: string;
    description: string;
    requirements: string[];
    /** Files to be used for campaign */
    contest_media?: string[];
    contest_video?: IProject;
    rating?: TRating;
    voting_required?: boolean;
    feature_image?: string;
    mobile_feature_image?: string;
    is_feature?: boolean;
    voting_type?: TVoting;
    tag?: string[];
    date_start: string;
    expiration_date: string;
    contest_phases_enabled?: boolean;
    premium?: boolean;
    submission_cost?: string;
    contest_phase_dates?: any[];
    partner?: string[];
    host?: string;
    technical_spec?: TTechnicalSpec;
    genre?: TContestGenre[];
    prize?: IContestPrize[];
    prizes?: IContestPrize[];
    jury?: IUserSummary[];
    _id?: string;
    id?: string;
    registration_required?: boolean;
    kind?: TKind;
    address?: string;
    late_entry: boolean;
    categories_enabled?: boolean;
    entry_type?: 'single' | 'multiple';
    preselection_enabled?: boolean;
    max_participants?: number | null;
    /** Hide public applications count and entry playlists. */
    hide_submissions_count?: boolean;

    currency?: string;
}

export interface ICreateContestResponse extends IContest {}

export interface IContestInitialState {
    contests: IContest[];
    gettingContests: boolean;
    contestErr: any;
    recommendations: IContest[];
    gettingRecommendations: boolean;
    contestInCreation?: IContest;
    userSubmissions: ISubmission[];
    gettingSubmissions: boolean;
    selectedContest?: IContest;
    loading?: boolean;
    similarContest?: IContest[];
    userContests: IContest[];
    isSubmisisonModalOpen: boolean;
    /** Set when opening checkout for an existing unpaid submission */
    existingPaySubmissionId?: string;
    selectedContestForSubmisison?: IContest;
    submittingProject: boolean;
    rescindingSubmission: boolean;
    initializingVote?: boolean;
    castingVote?: boolean;
    votes?: IVote[];
    voteErrMsg?: any;
    gettingBookmarks: boolean;
    userBookmarks: IBookmark[];
    creatingBookmark?: boolean;
    deletingBookmark?: boolean;
    deletingContest?: boolean;
    /** Client-side tombstones so deleted contests stay hidden after dashboard refetch. */
    deletedContestIds?: string[];
    hosts?: IHost[];
    partners?: IPartner[];
    creatingHost?: boolean;
    creatingPartner?: boolean;
    creatingContest?: boolean;
    searchingHost?: boolean;
    searchingPartner?: boolean;
    hostSearchResult?: IHost[];
    partnerSearchResult?: IPartner[];
    selectedContestForMetrics?: IAdvancedContest;
    markedForDelete: IBookmark[];
    redeemableCodes: IReedemableCode[];
    assigningCode?: boolean;
    fetchingAssignedCodes?: boolean;
    submissionsToVoteFor?: ISubmission[];
    showVotingBooth?: boolean;
    showVoting2Fa?: boolean;
    startingIndex?: number;
    selectedContestAwardCategories: IAwardCategory[];
    selectedContestPrizeWinners: IContestAward[];
    assigningPrize?: boolean;
    gettingContestAwardCategories?: boolean;
    /**
     * The below we will use to ask users to submit a project to a contest.
     * This only happens only when they triggered create project flow from the
     * campaignSubmitter modal. This will be true when the location is submission and there
     * is an active currently selected contest for submission and also a project in active mode
     */
    promptSubmission?: boolean;
    /** When a user selects auto submit for their project, we trigger this as true */
    autoPublishAndSubmit?: boolean;
    scoreBoard: IContestSubmissionsWithVotes[];
    fetchingScoreBoard?: boolean;
    creatingScorecategory?: boolean;
    /** This contest is the one that a user has opted in to submit to */
    focusCampaign?: IContest;
    emailImage?: string;
    references?: IProject[];
    gettingReferences?: boolean;
    unsubmittedProjects: IProject[];
    gettingUnSubmittedProjects?: boolean;
    currentUnsubmittedProjectsPage?: number;
    unsubmittedProjectErrMsg?: any;
    selectedCategoryForSubmission?: string | SubmissionCategory;
    gettingS3Images: boolean;
    loadingMoreS3Images: boolean;
    s3Images: string[];
    s3ImagesPagination: IS3ImagesPagination | null;
    contestSubmissions: IContestSubmissionsResponse['data'] | [];
    loadingSubmissions: boolean;
    searchingSubmissions: boolean;
    submissionsError: any;
    submissionsContest: IContest | null;
    availableFilters: { filter: string; display: string }[] | [];
    managedContest?: IContestManageResponse;
    managedContestLoading?: boolean;
    managedContestError?: any;
    updatingContest?: boolean;
    selectedCategory?: SubmissionCategory;
    /** Store the value here for the previous cateroy */
    initialSelectedCategory?: SubmissionCategory;
    selectedDiscount?: IDiscount;
    /** This is teh project selected to be used in submission */
    selectedProject?: IProject;
    /** Chosen tier for tiered submission mode */
    chosenTier?: { label?: string; fee?: number };
    // Video Management State
    preselectionSubmissions: IContestSubmissionsWithVotes[];
    gettingPreselectionSubmissions: boolean;
    preselectionPagination: PaginationResponse;
    preselectionError: string | null;
    selectedVideos: string[];
    videoManagementFilters: IVideoManagementFilters;
    sendingSelectionEmail: boolean;
    contestInFocusForToken?: string | null;
}

interface PaginationResponse {
    currentResults: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    limit: number;
    page: number;
    totalCount: number;
    totalPages: number;
}

export interface IBookmark {
    details: Details;
    created_at: string;
    _id: string;
    created_by: string;
    user: string;
    __v: number;
    id: string;
}
export interface Details {
    type: string;
    model: IContest;
}
export interface ISubmitProject {
    project: string;
    contest: string;
    reedemableCode?: string;
    isHostSubmission?: boolean;
    category?: string;
    saleId?: string;
    chosen_tier?: { label?: string; fee?: number };
}

export interface ICompleteSubmissionPayment {
    submissionId: string;
    saleId?: string;
}

export interface IRequestSubmissionPayment {
    contestId: string;
    submissionIds?: string[];
}

export interface IUpdateSubmission {
    submissionId: string;
    submission_picture?: string | File;
    testimonial_video?: string; // Project ID
    [key: string]: any;
}

export interface IGetContests {
    params?: string;
}

export interface IGetContestsResponse {
    data: IContest[];
    isFilitered?: boolean;
    extraDetails?: any;
}

export interface ISubmisisonModalPayload {
    open: boolean;
    selectedCategory?: SubmissionCategory;
    saleObject?: ISaleObject;
    currencyInfo?: ICurrencyInfo;
    chosen_tier?: { label?: string; fee?: number };
    /** Pay-later: complete checkout for an existing unpaid submission */
    existingSubmissionId?: string;
}

export interface IInitiate2FaForVote {
    phone_number?: string; // Making this optional as we will now pass phone number for logged in users in the backend
    submission_id: string;
    email?: string;
}

export interface IInitiate2FAResponse {
    verified: boolean;
    _id: string;
    phone_number: string;
    createdAt: string;
    updatedAt: string;
    id: string;
}

export interface ICastVote {
    submission_id: string;
    token_count: number;
    vote_count: number;
}

export interface IVote {
    _id: string;
    contest: IContest;
    submission: string;
    voter: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    id: string;
}

export type TBookmarkTypes =
    | 'Role'
    | 'Audition'
    | 'Vote'
    | 'Festival'
    | 'Award'
    | 'Profile'
    | 'Contest'
    | 'User'
    | 'Thougth'
    | 'Event';

export type TDetails = {
    type: TBookmarkTypes;
    model: string;
};

export interface ICreateBookmark {
    details: TDetails;
}

export interface ISocials {
    instagram: string | null;
    x: string | null;
    thspian: string | null;
    tik_tok: string | null;
    snapchat: string | null;
    linkedin: string | null;
    facebook: string | null;
}

export interface ICreateHost {
    name: string;
    description?: string;
    established?: string;
    profile_picture?: File;
    socials?: ISocials;
    website?: string;
}

export interface ICreatePartner {
    name: string;
    description?: string;
    established?: string;
    profile_picture?: File;
    socials?: ISocials;
    website?: string;
}

export type TContestFilter = 'date' | 'alphabetical' | 'most_votes' | 'winning_submissions';
export interface IGetUserContest {
    contestId: string;
    filter?: TContestFilter;
    start?: string;
    end?: string;
    withNavigate?: boolean;
    skipRefresh?: boolean;
}

export interface IGetSavedCollections {
    page?: number;
    limit?: number;
    type?: 'audition' | 'role' | 'contest' | 'vote' | 'festival';
}

export interface IGetUserContests {
    page?: number;
    limit?: number;
    params?: string;
    /** Super-admin only: omit created_by filter on /user-contest */
    scope?: 'all' | 'mine';
    /** Server-side title/slug search */
    search?: string;
    searchTerm?: string;
}

export interface IGetHost {
    hostId: string;
}

export interface IGetAllHosts {
    params?: string;
}

export interface IGetPartner {
    partnerId: string;
}

export interface IGetAllPartners {
    params?: string;
}

export interface ISearchPayload {
    searchTerm: string;
}

export interface ISearchHostResponse {
    result: IHost[];
    total_result_count: number;
}

export interface ISearchPartnerResponse {
    result: IPartner[];
    total_result_count: number;
}

export interface ICreateAwardCategory {
    category_title: string;
    prize: string;
    contest: string;
    year_started?: string;
    sub_category?: 'male' | 'female';
    /** The category of the submission which the award belongs to */
    category?: string;
    additional_prize?: string[];
    tier_name?: string; // tier label
    tier_position?: string; // position in prize structure
}

export interface IAwardCategory {
    category_title: string;
    prize: number | string;
    contest: string;
    additional_prize: string[];
    year_started?: string;
    sub_category?: 'male' | 'female';
    converted_amount_no_symbol?: string;
    transaction_currency?: string;
    currency?: string;
    rate?: number;
    bare_amount?: number;
    original_currency?: string;
    formatted_for_display?: string;
    defaulted_to_usd?: boolean;
    tier_name?: string; // tier label or tier _id
    tier_position?: string; // position in prize structure
    _id: string;
    event?: {
        type: 'Festival' | 'Contest';
        model: string;
    };
}

export interface IAssignRedeemableCode {
    userId: string;
    contestId: string;
}

export type TRedeemableCode = {
    _id: string;
    used: boolean;
    code: string;
    expiration_date: string;
    created_by: string;
    contest: string;
    createdAt: string;
    updatedAt: string;
    used_on?: string;
    user: string;
};

export interface IGetRedeemableCodes {
    contestId: string;
    page?: number;
    limit?: number;
}

export interface IDownloadAsset {
    key: string;
}

export interface ISetVotingFlow {
    submissions: ISubmission[];
    showVotingModal?: boolean;
}

export interface IAwardPrize {
    /** Use current year */
    award_year?: string | Date;
    /** Id of the award category */
    award_category?: IAwardCategory;
    /** Most won */
    award_status?: AwardStatus;
    /** Project ID */
    award_project?: string | IProjectSummary;
    /** User Id */
    person_awarded?: UserSummary;
    /**contestId */
    contest?: IContest;
    feature_image?: string;
    hash?: string;
}

export interface ICreateWinnersEmail {
    contestId: string;
    is_test?: boolean;
}
export interface ISendContestEmail {
    contestId: string;
    subject?: string;
    image?: string;
    message?: string;
    testUsers?: IUserSummary[];
    type?: string[];
    /** platform | participants | users — defaults to participants in contest management */
    audienceScope?: 'platform' | 'participants' | 'users' | 'advanced';
    /** Skip users who already received this email for this contest (default true) */
    doNotRepeat?: boolean;
    /** Full-width hero under the email curve */
    largeHeroImage?: boolean;
}
export interface IGetAllSubmissions {
    contestId: string;
    sortBy: 'total_votes' | 'createdAt';
    page?: number;
    limit?: number;
    refresh?: boolean;
}

export interface IGetSubmissions {
    page?: number;
    limit?: number;
    phase?: 'active' | 'past';
}

export interface IContestScoreResponse {
    submissions: IContestSubmissionsWithVotes[];
    details: IGetAllSubmissions;
}

export interface ICreateScoreCategory {
    category_title: string;
    tag: string[];
}

export interface IGetUnsubmittedProjects {
    contestId: string;
    sortBy?: 'asc' | 'desc';
    page?: number;
    limit?: number;
    searchTerm?: string;
}

export interface IGetUnsubmittedProjectsResponse {
    details: IGetUnsubmittedProjects;
    results: IProject[];
    current_page: number;
    total_pages: number;
    total_items: number;
}

export interface IGetContestSubmissions {
    contestId: string;
    page?: number;
    limit?: number;
    searchTerm?: string;
    sort?: TContestFilter;
    order?: 'asc' | 'desc';
}

export interface IEntryAward {
    _id: string;
    contest: string;
    award_project: string;
    award_category: AwardCategory;
    award_status: string;
    created_at: string;
}

export interface AwardCategory {
    _id: string;
    category_title: string;
    prize: string;
    sub_category: string;
}

export interface IEntries {
    _id?: string;
    project: IProject;
    user: IUserSummary;
    total_votes: number;
    awards: IEntryAward[];
    preselected?: boolean;
    position?: number;
}

export interface IAvailableFilter {
    filter: string;
    display: string;
}

export interface IContestSubmissionsResponse {
    status: string;
    currentPage: string;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    availableFilters: IAvailableFilter[];
    contest: IContest;
    results: number;
    data: IEntries[];
}

export type TSortBy = 'createdAt' | 'jury_score' | 'votes';
export type TCampCat =
    | 'submissions'
    | 'votes'
    | 'sales'
    | 'jurors'
    | 'engagement'
    | 'precomputed_stats'
    | 'awards'
    | 'discounts';
export type TCampSortOrder = 'desc' | 'asc';
export interface IGetManageCampiagn {
    contestId: string;
    salePage?: number;
    saleLimit?: number;
    searchTerm?: string;
    startDate?: string;
    endDate?: string;
    ticketType?: string;
    /**Sorting for submissions */
    sortBy?: TSortBy;
    sortOrder?: TCampSortOrder;
    submissionPage?: number;
    submissionLimit?: number;
    /** Add this dependnig on what tab we are on */
    category?: TCampCat;
    /** The is fecthed dynamically from the contest.categories array / Check the .category_name  */
    submissionCategory?: string;
}

export interface IContestPagination {
    currentPage: number;
    pageSize: number;
    totalCount: number;
    totalPages?: number;
}

export interface IManageContestSubmissions extends ISubmission {
    averageJuryScore: number;
    totalJuryScore: number;
    totalVotes: number;
    trending_marker: number;
    createdAt: string;
    updatedAt: string;
    chosen_tier?: { label: string; fee: number };
    preselected: boolean;
}
export interface IManageContestSubmission {
    data: IManageContestSubmissions[];
    pagination: IContestPagination;
}

export interface Juror {
    _id: string;
    accepted_invite: boolean;
    invite_sent: boolean;
    /** Total Assigned */
    total_assigned: number;
    /** Total completed submission */
    judged_submissions: number;
    /* This is the submission assigned to the juror */
    pending_submissions: ISubmission[];
    /** Percentage judged */
    judgment_percentage: number;
    /** This is the pagination details for the submisison assigned to the juror*/
    pending_pagination: PendingPagination;
    /** Juror details */
    juror: IUserSummary;
    /** Jury settings */
    jury_settings: IJurySetings;
}

export interface PendingPagination {
    currentPage: number;
    pageSize: number;
    totalPending: number;
    hasMore: boolean;
    remaining: number;
}

export interface JurorDetails {
    _id: string;
    firstName: string;
    lastName: string;
    userName: string;
    profile_picture?: string;
    location: ILocation;
    verified: boolean;
}

export interface IContestEngagement {
    likes: number;
    comments: number;
    views: number;
    total: number;
}

export interface ISubmissionStat {
    daily: Daily[];
    total: number;
}

export interface Daily {
    /** The date will always be the id */
    _id: string;
    count: number;
}

export interface IContestVoteStats {
    daily: VoteStats[];
    total: number;
}

export interface VoteStats {
    /** The date will always be the id */
    _id?: string;
    count: number;
}

export interface IContestEngagmentStat {
    likes: number;
    comments: number;
    views: number;
}

export interface IContestSalesStats {
    daily: ISale[]; // Verify this
    total: number;
}

export interface ContestPrecomposedStats {
    submissions: ISubmissionStat;
    votes: IContestVoteStats;
    engagement: IContestEngagmentStat;
    sales: IContestSalesStats;
}

export interface IContestSalesTotal {
    amount: number;
    usd_amount: number;
    /** The total formatted amount e.g  "$0.00" */
    formatted_amount: string;
    /** The total ampunt of sales made */
    count: string;
}

export interface ICampaignSaleItem {
    id: string;
    title: string;
    price: number;
    original_price: number;
    currency: string;
    quantity: number;
    breakdown?: {
        [key: string]: any;
        actual_amount: number;
    };
}

export interface SaleCurrencyInfo {
    transaction_currency: string;
    original_currency: string;
    rate: number;
}
export interface CampaignSaleMetadata {
    linked_event: string;
    linked_event_type: string;
    useAddressOnFile: boolean;
    currencyInfo: SaleCurrencyInfo;
    name: string;
    project: string;
}

export interface CampaignInvoice {
    amount: number;
    amount_captured: number;
    currency: string;
    formatted_amount: string;
    formatted_amount_captured: string;
}
export interface ICampaignSales {
    _id: string;
    category: string;
    items: ICampaignSaleItem[];
    name_used: string;
    original_currency: string;
    transaction_currency: string;
    price: number;
    linked_event: string;
    linked_event_type: string;
    email_used: string;
    metadata: CampaignSaleMetadata;
    created_by: IUserSummary;
    completed: boolean;
    refunded: boolean;
    location: ILocation;
    deleted: boolean;
    billing_address: string;
    exchange_rate: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
    invoice: CampaignInvoice;
    is_discounted: boolean;
    discount: any;
    usd_price: number;
    usd_discounted_price: number;
    formatted_price: string;
    formatted_usd_price: string;
    formatted_discounted_price: string;
    formatted_usd_discounted_price: string;
}
export interface IContestSales {
    total: IContestSalesTotal;
    data: ICampaignSales[];
    pagination: IContestPagination;
}

export interface ITopSubmission {
    /** ID of the submisison */
    submission: string;
    /**total votes for this submission */
    votes: number;
    /** To preview the submmission */
    video_id: string;
    title: string;
}

export interface IContestVotesByGroup {
    /** Will be the date e.g "2024-10-26" or null */
    _id: string;
    total_votes: number;
    /** Top 5 submissions for sorted by highest vote for this particular day */
    top_submissions: ITopSubmission[];
    /** remaning number of submissions not shown */
    remaining_submissions_count: number;
}
export interface IContestVotes {
    grouped: IContestVotesByGroup;
    /** Total votes cast for this campaign */
    total: number;
}

export interface IAwardStatus {
    nominated: number;
    won: number;
}

export interface IContestAwardCategory extends IAwardCategory {
    recipients: IAwardPrize;
}

export interface ISubCat {
    male: number;
    female: number;
}
export interface IContestAwardCategories {
    categories: IAwardCategory[];
    /** Total number of awards */
    total: number;
    by_sub_category: ISubCat;
}

export type TCouponType = {
    discount: number;
    coupon: number;
};

export type TDiscountStatus = {
    active: number;
    used: number;
    expired: number;
};
export interface IContestDiscounts {
    discounts: any[];
    total: number;
    by_type: TCouponType;
    by_status: TDiscountStatus;
}

export interface IManagedAwards {
    awards: IContestAward[];
    by_status: { nominated: number; won: number };
    total: number;
}

export interface IContestManageResponse {
    contest: IContest;
    submissions: IManageContestSubmission;
    awards: IManagedAwards;
    jurors: Juror[];
    engagement: IContestEngagement;
    sales: IContestSales;
    votes: IContestVotes;
    precomputed_stats: ContestPrecomposedStats;
    award_categories: IContestAwardCategories;
    discounts: IContestDiscounts;
    access?: {
        role?: string | null;
        can_edit?: boolean;
        can_moderate?: boolean;
        can_view_discounts?: boolean;
        can_manage_discounts?: boolean;
        can_see_sales_totals?: boolean;
        can_see_sales_detail?: boolean;
        can_view_prices?: boolean;
        can_manage_awards?: boolean;
        can_publish?: boolean;
        can_edit_hosts?: boolean;
        can_manage_team?: boolean;
        can_use_wallet?: boolean;
        can_delete?: boolean;
        can_see_finances?: boolean;
    };
}
// Video Management Types
export interface IGetPreselectionSubmissions {
    contestId: string;
    page?: number;
    limit?: number;
    category?: string[];
    searchTerm?: string;
    selection_state?: 'selected' | 'not_selected' | 'pending' | '';
    selection_email_sent?: boolean | '';
    pre_selection_completed?: boolean | '';
    sort?: 'total_average' | 'total_votes' | 'createdAt';
    order?: 'asc' | 'desc';
}

export interface IVideoManagementFilters {
    page: number;
    limit: number;
    category: string[];
    searchTerm: string;
    selection_state: 'selected' | 'not_selected' | 'pending' | '';
    selection_email_sent: boolean | '';
    pre_selection_completed: boolean | '';
    sort: 'total_average' | 'total_votes' | 'createdAt';
    order: 'asc' | 'desc';
}

export interface ISendSelectionEmail {
    contestId: string;
    submissionIds: string[];
    subject?: string;
    message?: string;
}

export interface ISetSelectedVideos {
    videoIds: string[];
}

export interface IPreselectSubmissions {
    contestId: string;
    submissionIds: string[];
    selection_state: 'selected' | 'not_selected';
}

export interface IUpdateVideoManagementFilters {
    filters: Partial<IVideoManagementFilters>;
}

interface BySubCategory {
    male: number;
    female: number;
}

export interface TCategoriesSummary {
    categories: IAwardCategory[];
    total: number;
    by_sub_category: BySubCategory;
}

export interface IContestFundingPosition {
    position: string;
    max_prize_cents: number;
    tier_label?: string;
    explanation?: string;
}

export interface IContestFundingAward {
    award_category_id: string;
    category_title: string;
    prize_cents: number;
    tier_label?: string;
    tier_name?: string;
}

export interface IContestFundingFeeExample {
    gross_cents: number;
    flat_fee_cents: number;
    percentage_fee_cents: number;
    percentage: number;
    total_fee_cents: number;
    net_prize_cents: number;
}

export interface IContestFundingPlatformFees {
    flat_fee_cents: number;
    percentage: number;
    applied_on?: string;
    custom_fee_source?: string;
    custom_service_charge_id?: string | null;
    example_for_shortfall?: IContestFundingFeeExample;
}

export interface IContestFundingRequirements {
    contest_id: string;
    contest_title: string;
    submission_mode?: string;
    currency: string;
    mode: 'tier' | 'regular';
    positions?: IContestFundingPosition[];
    awards?: IContestFundingAward[];
    non_tiered_awards_cents?: number;
    required_total_cents: number;
    formula?: string;
    funded_cents: number;
    /** Prizes already paid from escrow (cents). */
    spent_cents?: number;
    /** required_total_cents minus spent_cents. */
    outstanding_required_cents?: number;
    funding_shortfall_cents: number;
    gross_required_cents?: number;
    gross_locked_cents?: number;
    funding_shortfall_gross_cents?: number;
    platform_fees?: IContestFundingPlatformFees;
    is_fully_funded: boolean;
    funded: boolean;
    wallet_balance_cents: number;
    wallet_shortfall_cents: number;
    escrow?: unknown;
    funding_source?: string;
}

export interface IFundContestFromWalletPayload {
    contestId: string;
    amount_cents?: number;
}

export interface IFundContestFromWalletResult {
    escrow?: unknown;
    contest?: { _id: string; funded?: boolean; amount_available?: number };
    wallet_balance_cents?: number;
    requirements: IContestFundingRequirements;
    message?: string;
}

export type ContestSubmissionModeConvertDirection = 'to-regular' | 'to-tier';

export interface IConvertContestSubmissionModeToRegularBody {
    category_id?: string;
    default_tier_id: string;
    force?: boolean;
    keep_inactive_tiers?: boolean;
}

export interface IConvertContestSubmissionModeToTierBody {
    category_id?: string;
    tier_fee: Array<{
        label: string;
        fee: number;
        currency?: string;
        starts_at?: string | null;
        ends_at?: string | null;
        timezone?: string | null;
        is_active?: boolean;
        _id?: string;
    }>;
    seed_from_regular_fee?: boolean;
    map_regular_fee_to_label?: string;
}

export interface IConvertContestSubmissionModePayload {
    contestId: string;
    direction: ContestSubmissionModeConvertDirection;
    body: IConvertContestSubmissionModeToRegularBody | IConvertContestSubmissionModeToTierBody;
}

export interface IConvertContestSubmissionModeResult {
    contest_id?: string;
    submission_mode?: 'tier' | 'regular';
    category?: SubmissionCategory;
    funding_impact?: {
        required_total_cents?: number;
        amount_available?: number;
        shortfall_cents?: number;
        note?: string | null;
    };
    warnings?: string[];
    contest?: IContest;
}
